import React from "react"

import { NO, YES } from "const"
import { MtPackage } from "server/models"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"

import TableSelect from "../components/select"
import { styleOffset } from "./index"

const Task = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "taskModuleAccess",
            header: lang.taskModuleAccess,
            formatter: (packg: MtPackage) => {
                const { taskModuleAccess } = packg.settingsParsed
                return lang[taskModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { taskModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[taskModuleAccess]}
                        label={lang.taskModuleAccess}
                        property={{ taskModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "subTaskModuleAccess",
            header: lang.subTaskModuleAccess,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { subTaskModuleAccess } = packg.settingsParsed
                return lang[subTaskModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { subTaskModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[subTaskModuleAccess]}
                        label={lang.subTaskModuleAccess}
                        property={{ subTaskModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "taskGrantView",
            header: lang.taskGrantView,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { taskGrantView } = packg.settingsParsed
                return lang[taskGrantView]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { taskGrantView } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[taskGrantView]}
                        label={lang.taskGrantView}
                        property={{ taskGrantView }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "taskKanbanView",
            header: lang.taskKanbanView,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { taskKanbanView } = packg.settingsParsed
                return lang[taskKanbanView]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { taskKanbanView } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[taskKanbanView]}
                        label={lang.taskKanbanView}
                        property={{ taskKanbanView }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Task
